import { TreeMapNode, serializeTreeMap } from "@pinia/colada";
import { definePayloadPlugin, definePayloadReducer, definePayloadReviver } from "#app";
export default definePayloadPlugin(() => {
  definePayloadReducer("PiniaColada_TreeMapNode", (data) => {
    return data instanceof TreeMapNode && serializeTreeMap(data);
  });
  definePayloadReviver(
    "PiniaColada_TreeMapNode",
    (data) => data
  );
});
